import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { collection, doc, getDoc, getDocs, db, currentUser as getCurrentUser } from "../../services/firestoreApi";
import { useState } from "react";
import { useCookies } from "react-cookie";
import { auth } from "../firebase/FirebaseConfig";
import UserContext from "./UserContext";

//Componente de alto orden que nos ayuda a manejar el contexto del
// sitio y alamcena los estados y variables con que puede interactuar
// un lider 

export const UserState = (props) => {

    // coockie local del usuario
    const [cookies, setCookies, removeCookie] = useCookies(['user', 'carrito'])
    //estados para manejar las cookies
    const [state, setState] = useState(cookies.user)
    //variables para controlar el login
    const [loginError, setLoginError] = useState(false);
    //carrito de prductos del usuario
    const [carrito, setCarrito] = useState(cookies.carrito)

    const [loading, setLoading] = useState(false)
    //firebase login
    const Login = async (email, password) => {
        setLoginError(false)
        setLoading(true)

        try {
            let credential

            credential = await signInWithEmailAndPassword(auth, email, password)

            const profile = await getCurrentUser()
            const user = { id: credential.user.uid, data: profile.data }
            setCookies("user", user, { path: "/" })
            setState(user)
            if (user.data.current_orden) GetCarrito(user.data.current_orden)
            setLoginError(false)
        } catch (error) {
            await signOut(auth).catch(() => { })
            removeCookie('user', { path: "/" });
            removeCookie('carrito', { path: "/" });
            setState(undefined)
            setCarrito(undefined)
            setLoginError(true);
            return false;
        }

        setLoading(false);
        return true;
    }

    // Obtener el carrito del usuario
    const GetCarrito = async (id) => {
        const docRef = doc(db, "ordenes", id);
        const docSnap = await getDoc(docRef);
        setLoading(true)
        if (docSnap.exists()) {

            GetCarritoProductos(docSnap)

        } else {
            // doc.data() will be undefined in this case
            alert("error al obtener el carrito, por favor cierre sesion e intentelo de nuevo")
            signOut(auth).catch(() => { })
            removeCookie('user', { path: "/" });
            removeCookie('carrito', { path: "/" });
            setState(undefined)
            setCarrito(undefined)
            setLoginError(true);
        }
        setLoading(false)
    }

    const GetCarritoProductos = async (docSnap) => {
        setLoading(true)
        const querySnapshot = await getDocs(collection(db, "ordenes/" + docSnap.id + "/productos"));
        let productosAux = []
        let montoTotalAux = 0;
        let costoPesoExtra = 0;
        querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            productosAux.push({ id: doc.id, data: doc.data() })
            montoTotalAux = (parseFloat(montoTotalAux) + parseFloat(doc.data().total)).toFixed(2)
            costoPesoExtra = (parseFloat(costoPesoExtra) + parseFloat(doc.data().costo_peso_extra)).toFixed(2)
            //console.log("encuentra producto");
        });
        //   console.log(montoTotalAux)
        //console.log("update carrito!!")
        //console.log(productosAux); 
        setCookies("carrito", {
            id: doc.id,
            data: docSnap.data(),
            productos: productosAux,
            total: montoTotalAux,
            costo_peso_extra: costoPesoExtra
        }, { path: "/" });
        setCarrito({
            id: docSnap.id,
            data: docSnap.data(),
            productos: productosAux,
            total: montoTotalAux,
            costo_peso_extra: costoPesoExtra
        });
        // const unsub = onSnapshot(doc(db, "ordenes", docSnap.id), (doc) => {
        //     //console.log(cookies.carrito)
        //     //console.log(productosAux); 
        //     setCookies("carrito", {
        //         id: doc.id,
        //         data: doc.data(),
        //         productos: productosAux,
        //         total: montoTotalAux,
        //         costo_peso_extra: costoPesoExtra
        //     }, { path: "/" });
        //     setCarrito({
        //         id: docSnap.id,
        //         data: doc.data(),
        //         productos: productosAux,
        //         total: montoTotalAux,
        //         costo_peso_extra: costoPesoExtra
        //     });

        // });
        //console.log(querySnapshot.docs)

        setLoading(false)

    }
    const UpdateCarrito = async (id) => {
        setLoading(true)
        const querySnapshot = await getDocs(collection(db, "ordenes/" + id + "/productos"));
        let productosAux = []
        let montoTotalAux = 0;
        let costoPesoExtra = 0;
        querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            productosAux.push({ id: doc.id, data: doc.data() })
            montoTotalAux = (parseFloat(montoTotalAux) + parseFloat(doc.data().total)).toFixed(2)
            costoPesoExtra = (parseFloat(costoPesoExtra) + parseFloat(doc.data().costo_peso_extra)).toFixed(2)
            //console.log(doc.data());
        });
        //console.log(productosAux)
        setCookies("carrito", {
            id: carrito.id,
            data: carrito.data,
            productos: productosAux,
            total: montoTotalAux,
            costo_peso_extra: costoPesoExtra,
        }, { path: "/" });

        //console.log(querySnapshot.docs)
        setCarrito({
            id: carrito.id,
            data: carrito.data,
            productos: productosAux,
            total: montoTotalAux,
            costo_peso_extra: costoPesoExtra,
        });
        setLoading(false);
    }
    //cerrrar sesion
    const Logout = () => {
        setLoading(true)
        //console.log(cookies.user)
        removeCookie('user', { path: "/" });
        removeCookie('carrito', { path: "/" });
        //removeCookie("user", { path: "/" })
        console.log("logout ");
        setState(undefined)
        setCarrito(undefined)
        setLoading(false)
        //window.location.reload()
    }
    const LogoutAdmin = Logout

    //variable para manejar las pantallas y el es estatus de la compra
    // maneja las pantallas de /canasta tambien
    // Tipos dr estatus
    //En revisión
    //En espera de pago
    //En camino
    //

    const [statusCompra, setStatusCompra] = useState("")

    //variables para controlar los productos seleccionados 
    // por el usuario asi como las redes y subredes que ha escojido

    const [selectedRed, setSelectedRed] = useState("")
    const [selectedSubRed, setSelectedSubRed] = useState("")
    const [selectedProducto, setSelectedProducto] = useState("")
    return (
        <UserContext.Provider value={{
            user: state,
            auth,
            Login,
            carrito, GetCarrito, UpdateCarrito, setCarrito,
            AdminLogin: Login,
            loginError,
            Logout,
            LogoutAdmin,

            cookies,
            setCookies,

            statusCompra,
            setStatusCompra,

            selectedRed,
            setSelectedRed,

            selectedSubRed,
            setSelectedSubRed,

            selectedProducto,
            setSelectedProducto,

            loading,
            setLoading
        }}>
            {props.children}
        </UserContext.Provider>
    )

}